import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { City, District, Prop } from '../../interfaces/prop.interface';
import { propsOriginalJson } from '../../data/propsoriginal.json';

import { propsFoundJson } from '../../data/propsfound.json';
import { propsJson } from '../../data/props.json';

import { propsids } from '../../data/propsids.json';

@Component({
  selector: 'app-geocoding',
  templateUrl: './geocoding.component.html',
  styleUrls: ['./geocoding.component.css']
})
export class GeocodingComponent implements OnInit {

  // Listados para geocoding
  listadoOriginal: any[] = propsOriginalJson;
  listadoFinal: any[] = [];

  // Listados para matcheo (solo añadir coordenadas)
  listadoProps: Prop[] = propsJson;
  listadoFound: any[] = propsFoundJson;

  // Listado para añadir ids a las propiedades
  listadoIds: any[] = propsids;

  latLngService: any;
  total: number = 0;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    // Obtener coordenadas de las propiedades
    //this.getLatLngProps()

    // Añadir coordenadas a las propiedades
    // this.listadoFound.forEach(propFound => {
    //   this.listadoProps.forEach(prop => {
    //     if (prop.id === propFound.id) {
    //       prop.lat = propFound.lat;
    //       prop.lng = propFound.lng;
    //     }
    //   })
    // })

    this.listadoProps.forEach(prop => {
      this.listadoIds.forEach(propId => {
        if (prop.id === propId.id) {
          prop.id_ext = propId.id_ext;
        }
      })
    })

  }



  getLatLngProps() {
    this.listadoOriginal.forEach(prop => {
      const search = prop.address + prop.municipio;
      console.log(search)

      this.getLatLng(search).subscribe((data: any) => {
        this.listadoFinal.push({
          id: prop.id,
          active: prop.active,
          status: prop.status,
          strategy: prop.strategy,
          city: prop.city,
          province: prop.province,
          CCAA: prop.CCAA,
          country: prop.country,
          use: prop.use,
          smokeStractor: prop.smokeStractor,
          surfacebr: prop.surfacebr,
          surfaceMezzanine: prop.surfaceMezzanine,
          surfacepb: prop.surfacepb,
          surfaceBasement1: prop.surfaceBasement1,
          surfaceBasement2: prop.surfaceBasement2,
          surfaceRest: prop.surfaceRest,
          surfacesr: prop.surfacesr,
          surfaceBasement: prop.surfaceBasement,
          surfaceFloor1: prop.surfaceFloor1,
          surfaceFloor2: prop.surfaceFloor2,
          surfaceWeighted: prop.surfaceWeighted,
          surfaceTotal: prop.surfaceTotal,
          timeAvailableFrom: prop.timeAvailableFrom,
          name: prop.name,
          visible: prop.visible,
          features: prop.features,
          highLights: prop.highLights,
          descshort: prop.descshort,
          descLong: prop.descLong,
          comment: prop.comment,
          address: prop.address,
          postalCode: prop.postalCode,
          // lat: data.features[0].center[1],
          // lng: data.features[0].center[0]
          lat: data.results[0].geometry.location.lat,
          lng: data.results[0].geometry.location.lng
        })

      })
    })
  }

  getLatLng(search: string) {
    const apiGoogle = "AIzaSyC6wVkq4jYS_FvMfQ5dPZW6wY0GHqzTCi8"
    const token = "pk.eyJ1IjoiZ3V6bWFucyIsImEiOiJjbDVqYTFiOXgwNGdpM2ptb3hxN2Q0NXN5In0.lqQrzINVkeZGJoIy03VaIw"
    const url = "https://api.mapbox.com/geocoding/v5/mapbox.places/" + search + ".json?access_token=" + token

    const urlGoogle = "https://maps.googleapis.com/maps/api/geocode/json?address=" + search + "&key=" + apiGoogle

    let data = this.http.get<any>(urlGoogle);
    return data


  }




}
